export default function getResource(label, vars = []) {
    const resources = {
        yearAtGlanceTitle: `${vars[0]} en un coup d’œil`,
        yearAtGlanceError: 'Nous n’arrivons pas charger votre historique annuel pour le moment.',
        yearAtGlanceSignedOut: `Ouvrez une session pour accéder à votre ${vars[0]} en un coup d’œil.`,
        yearAtGlanceNonBi: `Adhérez pour accéder à votre ${vars[0]} en un coup d’œil.`,
        yearAtGlanceEmpty: `Vos gains ${vars[0]} apparaîtront ici. Continuez à magasiner pour obtenir des récompenses, des privilèges et des réductions!`,
        rewardsRedeemedTitle: 'Récompenses réclamées',
        rewardsRedeemedError: 'Nous n’arrivons pas à charger vos récompenses utilisées pour le moment.',
        rewardsRedeemedSignedOut: 'Ouvrez une session pour accéder à vos récompenses utilisées.',
        rewardsRedeemedNonBi: 'Inscrivez-vous pour commencer à accumuler des points et à profiter des récompenses.',
        rewardsRedeemedEmpty: 'Vos récompenses réclamées s’afficheront ici.',
        pointsHistoryTitle: 'Historique de points',
        pointsHistoryInfoLabel: 'Renseignements sur l’historique de points',
        pointsHistoryError: 'Nous n’arrivons pas à charger votre historique de points pour le moment.',
        pointsHistorySignedOut: 'Ouvrez une session pour accéder à votre historique de points.',
        pointsHistoryNonBi: 'Inscrivez-vous pour commencer à accumuler des points et faire le suivi de votre historique de points.',
        pointsHistoryEmpty: 'Votre historique de points s’affichera ici.',
        pointsDisclaimer: 'Vous ne voyez toujours pas vos points? Votre activité sera mise à jour dans les 24 heures.',
        pointsInfoModalMessage: 'Les points accumulés lors des achats et activités admissibles peuvent prendre jusqu’à 24 heures avant d’apparaître dans votre compte.',
        modalOk: 'OK',
        viewDetails: 'Voir les détails',
        viewAll: 'Tout afficher',
        shopNow: 'Magasiner',
        retry: 'Réessayer',
        loadingPointsHistory: 'Chargement de l’historique de points',
        faqs: 'FAQ',
        terms: 'Modalités Beauty Insider',
        employeeDiscountPurchase: 'Achat avec rabais de membre du personnel',
        employeeDiscountDescription: `${vars[0]} of ${vars[1]} limit available until ${vars[2]}`,
        promosAndDiscountApplied: 'Promotions et réductions appliquées',
        beautyInsiderCashApplied: 'Dollars Beauty Insider appliqués',
        creditCardRewardsEarned: 'Récompenses carte de crédit obtenues',
        rougeRewardsEarned: 'Récompenses Rouge obtenues'
    };

    return resources[label];
}
